import React, { FunctionComponent, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all_with_count, fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
// import { currentPracticeAtom } from '../../../lib/practice';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

// import {
//   Badge,
// } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import {
  DataGrid,
  // Dt,
  Fab,
  IconButton,
  Page
} from '../../../components/v2/styled';
import { SearchBox } from '../../../components/v2/SearchBox';
import { SnackDestroyed } from '../../../components/v2/snacks/Destroyed';

import { AdhProfile } from '../../../models/AdhProfile';

// const { DateTime } = require("luxon");

type Props = {}

export const AdminFoodCalculationAdhProfiles: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  // const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  // const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  let count = 0;
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("name ASC");
  const [search, setSearch] = useState<string>("");

  const [destroyedOpen, setDestroyedOpen] = useState<boolean>(false);

  const {
    data: objects,
    isLoading: objectsLoading,
    isError: objectsError,
    isSuccess: objectsSuccess,
    refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["admin", "adh_profiles", {page: page, order: order, search: search}],
    queryFn: () =>
      fetch_all_with_count<AdhProfile>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'adh_profile',
          fields: ['id', 'name', 'age_low', 'age_high', 'gender', 'is_pregnant', 'country', 'practice', 'adh_links'],
          sub_fields: {
            country: ['id', 'name', 'iso'],
            practice: ['id', 'name'],
            adh_links: ['id', 'nutritional_value'],
            nutritional_value: ['id', 'name'],
          },
          order: order,
          per_page: 20,
          page: page,
          filter: {
            search: search,
            advanced: {
              is_admin: 1,
              no_user: 1
            }
          }
        },
        login
      ),
    select: (d) => {
      count = d.count;
      return d.result;
    },
    enabled: !!login?.id
  });







  const mutationDestroy = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<AdhProfile>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/remove`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setDestroyedOpen(true);
      objectsRefetch();
    },
  });








  const columns: GridColDef[] = [
    // { field: 'id', headerName: 'ID', width: 80 },
    { field: 'practice_name', headerName: t("coach.models.adh_profiles.practice"), width: 150 },
    { field: 'country_name', headerName: t("admin.models.adh_profiles.country"), width: 100, renderCell: params => <>{params.row.country_name || "-"}</> },
    { field: 'name', headerName: t("coach.models.adh_profiles.name"), width: 250 },
    { field: 'age', headerName: t("coach.models.adh_profiles.age"), width: 100 },
    { field: 'gender', headerName: t("coach.models.adh_profiles.gender"), width: 100 },
    { field: 'adh_link_length', headerName: t("coach.models.adh_profiles.adh_links"), width: 100 },
  ];

  return <Page title={t("admin.menu.adh_profiles")}>
    <SearchBox
      search={search}
      setSearch={setSearch}
      objectCount={count}
    />

    <DataGrid
      action_count={2}
      hideCount
      actions={(params) => {
        return (<>
          <IconButton title="Edit" color="default" path={`/adh_profile/${params.row.id}`}>
            <EditIcon />
          </IconButton>
          <IconButton title="Remove" destroyBtn color="default" onClick={() => {
            mutationDestroy.mutate({
              formData: {
                object: 'adh_profile',
                id: params.row.id,
                ob: {
                  id: params.row.id,
                }
              }
            });
          }}>
            <DeleteIcon />
          </IconButton>
        </>);
      }}
      objectCount={count}
      getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
      objects={(objects || []).map(u => ({
        ...u,
        age: !!u.age_low && !!u.age_high ? [u.age_low, u.age_high].join("-") : (!!u.age_low ? u.age_low : u.age_high),
        adh_link_length: (u.adh_links || []).length,
        practice_name: u.practice?.name,
        country_name: u.country?.name
      }))}
      columns={columns}
      loader={objectsLoading}
      onSortModelChange={(a, b) => {
        let a_0_field:string = a[0].field;
        if (a_0_field === 'name') a_0_field = `last_name ${a[0].sort}, first_name`;
        setOrder([a_0_field, a[0].sort].join(' '));
      }}
      page={page}
      setPage={(p) => {setPage(p);}}
    />

    <SnackDestroyed open={destroyedOpen} setOpen={setDestroyedOpen} />

    <Fab
      onClick={() => {
        navigate("/adh_profile/new", {});
      }}
    />
  </Page>;
}
